// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"WS-z","smallCardRow":"XS-z","largeCardRow":"YS-z","productSearchRow":"ZS-z","curatedRow":"_S-z"};